import * as React from "react";
const LiquorIcon = require('!svg-react-loader?name=LiquorIcon!../../../../wwwroot/img/liquor-connect-logo.svg');
export default class Footer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "footer-A" },
            React.createElement("div", { className: "footer-top" },
                React.createElement("div", { className: "footer-logo" },
                    React.createElement("span", null, "POWERED BY "),
                    React.createElement(LiquorIcon, { className: "liquor-logo" }))),
            React.createElement("footer", { className: "site-footer" },
                React.createElement("div", { className: "links" },
                    React.createElement("div", { className: "link-section" },
                        React.createElement("p", null, "CORPORATE INFORMATION"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Home/Social" }, "Social Responsibility")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Home/Faq" }, "FAQ")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Home/Events" }, "Events")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "http://www.connect-logistics.com/" }, "Corporate Site")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Home/Contact" }, "Contact")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Home/PrivacyPolicy" }, "Privacy Policy")))),
                    React.createElement("div", { className: "link-section" },
                        React.createElement("p", null, "PRODUCTS"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?madeInAlberta=true" }, "Alberta Made")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?category=WINE" }, "Wine")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?category=BEER" }, "Beer")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?category=SPIRITS" }, "Spirits")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?category=LIQUEUR" }, "Liqueurs")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?category=CIDERS%20%26%20COOLERS" }, "Ciders & Coolers")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?liqType=liqType=NON-ALCOHOLIC&category=NON-ALCOHOLIC" }, "Non-Alcoholic")),
                            React.createElement("li", null,
                                React.createElement("a", { href: "/Products/Search?liqType=LIQUOR%20ACCESSORIES%2CPRODUCT%20PACKAGING&category=NON-ALCOHOLIC" }, "Other")))),
                    React.createElement("div", { className: "link-section" },
                        React.createElement("p", null, "RESOURCES"),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("a", null, "My Account Sign In")),
                            React.createElement("li", null,
                                React.createElement("a", null, "Product Search")),
                            React.createElement("li", null,
                                React.createElement("a", null, "Store Locator")),
                            React.createElement("li", null,
                                React.createElement("a", null, "Help"))))),
                React.createElement("div", { className: "details" },
                    React.createElement("div", { className: "disclaimer" },
                        React.createElement("p", null, "DISCLAIMER"),
                        React.createElement("p", null, "Products may vary by location. Items may not be exactly as shown."),
                        React.createElement("p", null, "Please contact the store to confirm availability. A retailer may sell out of any product at any time.")),
                    React.createElement("div", { className: "getTheApp" },
                        React.createElement("p", null, "GET THE APP"),
                        React.createElement("div", null,
                            React.createElement("img", { className: "google-logo", src: "/img/download-apple.svg" }),
                            React.createElement("img", { className: "google-logo", src: "/img/google-play-badge.png" })))),
                React.createElement("div", { className: "copyright" },
                    React.createElement("span", null, "\u00A9 2020 Connect Logistics Services. All rights reserved")))));
    }
}
;
//# sourceMappingURL=footer.js.map